export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('lignesCommande') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Libelle') {
      return i18n.t('editionCreationDepenseBailleur.messages.error.name.libelleLigneCommande');
    }
    if (libellePropriete === 'Quantite') {
      return i18n.t('editionCreationDepenseBailleur.messages.error.name.quantiteLigneCommande');
    }
    if (libellePropriete === 'PrixUnitaire') {
      return i18n.t('editionCreationDepenseBailleur.messages.error.name.prixUnitaireLigneCommande');
    }
    if (libellePropriete === 'Remise') {
      return i18n.t('editionCreationDepenseBailleur.messages.error.name.remiseLigneCommande');
    }
    if (libellePropriete === 'TauxTva') {
      return {
        message: 'editionCreationDepenseBailleur.messages.error.name.tauxTvaLigneCommande',
      };
    }
    if (libellePropriete.indexOf('LignesCommande') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Quantite') {
        return i18n.t('editionCreationDepenseBailleur.messages.error.name.quantiteLigneCommande');
      }
      if (libellePropriete === 'PrixUnitaire') {
        return i18n.t('editionCreationDepenseBailleur.messages.error.name.prixUnitaireLigneCommande');
      }
      if (libellePropriete === 'Remise') {
        return i18n.t('editionCreationDepenseBailleur.messages.error.name.remiseLigneCommande');
      }
    }
    if (libellePropriete.indexOf('LignesRemise') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Remise') {
        return i18n.t('editionCreationDepenseBailleur.messages.error.name.remise');
      }
    }
    return libellePropriete;
  }
  if (propriete.indexOf('echeanciersPaiement') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'dateEcheance') {
      return i18n.t('validationFacture.name.dateEcheance');
    }
    if (libellePropriete === 'montant') {
      return i18n.t('validationFacture.name.montant');
    }
  }
  if (propriete.indexOf('echeancierPaiement') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'dateEcheance') {
      return i18n.t('validationFacture.name.dateEcheance');
    }
    if (libellePropriete === 'montant') {
      return i18n.t('validationFacture.name.montant');
    }
  }
  if (propriete === 'dateDevisCommande') {
    return i18n.t('editionCreationDepenseBailleur.messages.error.dateDepense');
  }
  if (propriete === 'agence') {
    return i18n.t('editionCreationDepenseBailleur.messages.error.agence');
  }
  return propriete;
}
